import React from 'react'

import './BetaTag.css'

function BetaTag (): React.ReactElement {
  return <span className="beta-tag">BETA</span>
}

export default BetaTag
